/* Les portes de creation s'ouvrent DANS la fiche produit.

   ⛔ SORTIR DE LA FICHE, C'EST PERDRE LA VENTE. « Composer mon mur » et « Accorder a
   ma piece » ouvraient une autre page : le client quittait l'affiche qu'il regardait,
   avec sa taille et son cadre deja choisis, et rien ne le ramenait (Adrien,
   03/08/2026). Ils s'ouvrent maintenant dans un panneau plein ecran par-dessus la
   fiche, ferme par une croix ; dessous, la fiche n'a pas bouge.

   ⛔ PAS D'IFRAME, SHOPIFY LE REFUSE. Toute page de la boutique repond
   `X-Frame-Options: DENY` et `frame-ancestors 'none'`, y compris pour sa propre
   origine : un cadre reste desesperement blanc, et le theme ne peut pas retirer un
   en-tete pose par la plateforme. On charge donc le CONTENU de la page et on le pose
   dans le document, ce qui ne passe par aucune regle de cadrage.

   Le panneau garde ce qu'il a construit : rouvert, il retrouve le mur en cours de
   composition plutot que de repartir d'une page blanche.

   Les liens restent des liens : sans JS, sur un Cmd-clic ou un clic milieu, ils
   menent a la page comme n'importe quel lien du site. */
(function () {
  var liens = document.querySelectorAll("[data-modale]");
  if (!liens.length) return;

  var boite = null, dernierFocus = null;
  var voile = null;
  var caches = {};                      // url -> corps deja construit
  var bloc = document.querySelector("[data-modale-fermer]");
  var motFermer = (bloc && bloc.getAttribute("data-modale-fermer")) || "Fermer";

  function memeOrigine(href) {
    try { return new URL(href, location.href).origin === location.origin; }
    catch (e) { return false; }
  }

  function feuilleChargee(href) {
    var chemin;
    try { chemin = new URL(href, location.href).pathname; } catch (e) { return true; }
    var liste = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < liste.length; i++) {
      try { if (new URL(liste[i].href, location.href).pathname === chemin) return true; } catch (e) {}
    }
    return false;
  }

  function poseFeuille(href) {
    return new Promise(function (ok) {
      var l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = href;
      l.onload = ok;
      l.onerror = ok;                   // une feuille manquante ne doit pas bloquer l'outil
      document.head.appendChild(l);
    });
  }

  /* ⛔ LES SCRIPTS POSES PAR innerHTML NE S'EXECUTENT PAS. Il faut les recreer, dans
     l'ordre, et attendre chaque script externe avant le suivant : la configuration
     inline de la page precede son outil et doit exister quand celui-ci demarre.

     On ne rejoue QUE les scripts du contenu. Ceux de la mise en page sont deja la, et
     l'un d'eux redirige selon la langue : le rejouer rechargerait la boutique. */
  function rejoueScripts(racine) {
    var scripts = Array.prototype.slice.call(racine.querySelectorAll("script"));
    return scripts.reduce(function (chaine, vieux) {
      return chaine.then(function () {
        return new Promise(function (ok) {
          var neuf = document.createElement("script");
          for (var i = 0; i < vieux.attributes.length; i++) {
            neuf.setAttribute(vieux.attributes[i].name, vieux.attributes[i].value);
          }
          if (vieux.src) { neuf.onload = ok; neuf.onerror = ok; }
          else neuf.textContent = vieux.textContent;
          vieux.parentNode.replaceChild(neuf, vieux);
          if (!vieux.src) ok();
        });
      });
    }, Promise.resolve());
  }

  function construit(url) {
    if (caches[url]) return Promise.resolve(caches[url]);
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var main = doc.getElementById("MainContent") || doc.querySelector("main");
        if (!main) return Promise.reject();
        /* Dedoublonnage DANS le lot aussi : la page peut declarer deux fois la meme
           feuille, et `feuilleChargee` ne voit que ce qui est deja dans le document. */
        var vues = {}, feuilles = [];
        Array.prototype.forEach.call(doc.querySelectorAll('link[rel="stylesheet"]'), function (l) {
          var h = l.getAttribute("href");
          if (!h || feuilleChargee(h)) return;
          /* Le doublon se juge sur le CHEMIN : la meme feuille est declaree deux fois
             avec deux jetons de cache differents, et une cle sur l'adresse entiere ne
             les rapprochait pas. */
          var cle;
          try { cle = new URL(h, location.href).pathname; } catch (e) { cle = h; }
          if (vues[cle]) return;
          vues[cle] = 1;
          feuilles.push(h);
        });
        var corps = document.createElement("div");
        corps.className = "modale-creation__corps";
        corps.innerHTML = main.innerHTML;
        caches[url] = corps;
        return Promise.all(feuilles.map(poseFeuille)).then(function () { return corps; });
      });
  }

  function ferme() {
    if (!boite) return;
    document.body.classList.remove("modale-ouverte");
    /* Le contenu retourne au cache : la composition en cours survit a la fermeture. */
    var corps = boite.querySelector(".modale-creation__corps");
    if (corps && corps.parentNode) corps.parentNode.removeChild(corps);
    if (boite.parentNode) boite.parentNode.removeChild(boite);
    if (voile) voile.remove();
    voile = null;
    boite = null;
    document.removeEventListener("keydown", auClavier, true);
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function auClavier(e) {
    if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); ferme(); }
    if (e.key === 'Tab' && boite) {
      var focusables = Array.from(boite.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(function (element) { return element.getClientRects().length; });
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first && last) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last && first) { e.preventDefault(); first.focus(); }
    }
  }

  function ouvre(href, titre, source) {
    dernierFocus = source || null;
    boite = document.createElement("div");
    boite.className = "modale-creation";
    boite.setAttribute("role", "dialog");
    boite.setAttribute("aria-modal", "true");
    boite.setAttribute("aria-label", titre || "");

    var barre = document.createElement("div");
    barre.className = "modale-creation__barre";
    var t = document.createElement("p");
    t.className = "modale-creation__titre";
    t.textContent = titre || "";
    var x = document.createElement("button");
    x.type = "button";
    x.className = "modale-creation__x";
    x.setAttribute("aria-label", motFermer);
    x.innerHTML = "&times;";
    x.addEventListener("click", ferme);
    barre.appendChild(t);
    barre.appendChild(x);

    var attente = document.createElement("div");
    attente.className = "modale-creation__attente";
    attente.setAttribute("aria-live", "polite");

    boite.appendChild(barre);
    boite.appendChild(attente);
    voile = document.createElement('div');
    voile.className = 'modale-creation-backdrop';
    var outside = false;
    voile.addEventListener('pointerdown', function (event) { outside = event.target === voile; });
    voile.addEventListener('click', function (event) {
      if (outside && event.target === voile) ferme();
      outside = false;
    });
    voile.appendChild(boite);
    document.body.appendChild(voile);
    document.body.classList.add("modale-ouverte");
    x.focus();
    document.addEventListener("keydown", auClavier, true);

    var neuf = !caches[href];
    construit(href).then(function (corps) {
      if (!boite) return;                       // ferme avant la fin du chargement
      if (attente.parentNode) attente.parentNode.removeChild(attente);
      boite.appendChild(corps);
      /* ⛔ LA PORTE SE DECLARE AVANT QUE L'OUTIL DEMARRE. Le composeur mesure d'ou on
         l'ouvre, et il ne peut pas le deduire : ouvert ici, il n'y a EU AUCUNE NAVIGATION,
         donc `document.referrer` vaut le referent de la fiche et non la fiche. Un visiteur
         venu de Google etait compte « direct » (Adrien, 07/08/2026). Le drapeau est pose
         avant `rejoueScripts`, qui est le moment ou l'outil s'execute et emet son arrivee. */
      var porte = source && source.getAttribute && source.getAttribute("data-creation-source");
      var handleSource = source && source.getAttribute && source.getAttribute("data-creation-handle");
      if (!porte) {
        porte = location.pathname.indexOf("/products/") >= 0 ? "produit" : "menu";
        if (porte === "produit" && !handleSource) {
          /* Le repli lit le chemin : c'est la fiche hote, donc le bon handle. */
          handleSource = (location.pathname.split("/products/")[1] || "").split(/[?#/]/)[0];
        }
      }
      window.__creationSource = porte === "produit" && handleSource ? porte + ":" + handleSource : porte;
      /* ⛔ ET L'URL DEMANDEE SE DECLARE ICI POUR LA MEME RAISON. La barre d'adresse reste
         celle de l'article : un outil qui lit `location.search` n'y trouve rien de ce que le
         lien portait. Le composeur a lu une URL sans `?affiches=`, a cru a une arrivee
         ordinaire, et a repose les dernieres affiches consultees a la place des six proposees
         (Adrien, 16/08/2026). Elle est posee a CHAQUE ouverture, donc jamais perimee : rouvrir
         depuis le menu la remplace par une URL sans parametre. */
      window.__creationUrl = href;
      /* ⚠️ ET LE JETON DE SESSION EST CONSOMME ICI AUSSI. Le clic l'a depose pour le cas d'une
         vraie navigation ; ouvert en modale, personne ne le relit, et il resterait a trainer
         pour la prochaine ouverture, qui serait alors attribuee a la mauvaise porte. */
      try { sessionStorage.removeItem("af:creation-src"); } catch (err) {}
      /* Les scripts ne se rejouent qu'une fois : au retour, l'outil est deja vivant. */
      if (neuf) rejoueScripts(corps);
    }).catch(function () {
      /* Le chargement a echoue : plutot qu'un panneau vide, on emmene le client a la
         page, qui est le comportement d'avant. */
      ferme();
      location.href = href;
    });
  }

  Array.prototype.forEach.call(liens, function (a) {
    a.addEventListener("click", function (e) {
      /* On laisse au navigateur ce qui lui appartient : nouvel onglet, clic milieu. */
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var href = a.getAttribute("href");
      if (!href || !memeOrigine(href)) return;
      e.preventDefault();
      ouvre(href, a.getAttribute("data-modale-titre") || a.textContent.trim(), a);
    });
  });

  /* ⛔ UN AJOUT AU PANIER FERME LE PANNEAU. Le tiroir s'ouvre par-dessus tout, mais
     laisser le panneau dessous mettrait le client devant deux couches : il vient
     d'acheter, on le ramene a la fiche. */
  window.addEventListener("af:panier", ferme);
})();
